import { useMemo } from "react";
import { useConsultantRoutable } from "@tecnobit-srl/consultancies-routable-types-consultant/lazy";
//#region src/index.ts
var useConsultanciesRoutableTypes = () => {
	const consultantRoutable = useConsultantRoutable();
	return useMemo(() => ({ ...consultantRoutable }), [consultantRoutable]);
};
//#endregion
export { useConsultanciesRoutableTypes };
